import type { Location, Patient, Reference } from '@medplum/fhirtypes'
import {
  ExtendedEncounter,
  type ExtendedEncounterArgs,
} from '#src/models/encounters/encounter.ts'
import { LocationBasedEncounter } from '#src/models/encounters/location-encounter.ts'
import type { QueryTypes } from '#src/search.ts'

export class FacilityEncounter extends LocationBasedEncounter {
  constructor(
    args: Omit<ExtendedEncounterArgs, 'class' | 'location'> & {
      location: Reference<Location>
    }
  ) {
    super({
      ...args,
      class: 'ONSITE',
      location: args.location,
    })
  }

  static readonly BASE_SEARCH_QUERY: QueryTypes = {
    ...ExtendedEncounter.BASE_QUERY_STRUCTURE,
    class: ExtendedEncounter.ENCOUNTER_CLASS.ONSITE,
  }

  static searchByPatient(patient: Reference<Patient>): QueryTypes {
    return {
      ...this.BASE_SEARCH_QUERY,
      subject: patient,
    }
  }

  static byPatientInProgress(patient: Reference<Patient>): QueryTypes {
    return {
      ...this.BASE_SEARCH_QUERY,
      subject: patient,
      status: 'in-progress',
    }
  }
}
